import type { KnowledgeDoc, KnowledgeDocId, MockCache } from '../types';

function childrenOf(cache: MockCache, id: KnowledgeDocId): KnowledgeDoc[] {
  const children: KnowledgeDoc[] = [];
  for (const doc of cache.docs.values()) {
    if (doc.parentId === id) {
      children.push(doc);
    }
  }
  return children;
}

export function docSubtree(cache: MockCache, doc: KnowledgeDoc, include: (member: KnowledgeDoc) => boolean = () => true): KnowledgeDoc[] {
  return [doc, ...childrenOf(cache, doc.id).filter(include).flatMap((child) => docSubtree(cache, child, include))];
}

function isArchivedRoot(cache: MockCache, doc: KnowledgeDoc): boolean {
  if (doc.archivedAt === null) {
    return false;
  }
  const parent = doc.parentId === null ? undefined : cache.docs.get(doc.parentId);
  return parent === undefined || parent.archivedAt === null;
}

export function archivedDocs(cache: MockCache): KnowledgeDoc[] {
  const roots: KnowledgeDoc[] = [];
  for (const doc of cache.docs.values()) {
    if (doc.workspaceId === cache.activeWorkspaceId && isArchivedRoot(cache, doc)) {
      roots.push(doc);
    }
  }
  return roots.sort((left, right) => Number(right.archivedAt) - Number(left.archivedAt) || (left.id < right.id ? -1 : 1));
}

export function archivedSubtreeCount(cache: MockCache, id: KnowledgeDocId): number {
  const doc = cache.docs.get(id);
  return doc === undefined ? 0 : docSubtree(cache, doc).length - 1;
}
